<template>
<div>
  <v-card :dark='dark' tile flat
    v-if='appointment && appointment.id && table && table.data && table.activeCodeTypes' >

    <v-card-title v-if='withTitle' class='py-2 mr-4 pr-5' >

      <v-menu >
        <template v-slot:activator="{ on }">
        <v-btn v-on='on' slot='activator' small icon >
          <v-icon>more_vert</v-icon>
        </v-btn>
        </template>
        <v-list dense class='pa-0' >
          <v-subheader class='overline py-0 grey lighten-4 overline pl-4' >
            Coding utilities
            <v-spacer/>
            <v-btn small icon ><v-icon small >close</v-icon></v-btn>
          </v-subheader>
          <v-divider/>

          <v-list-tile>
            <v-btn flat small
              @click='showOrder=true'
              :disabled='table.data.length <= 1' >
              Set order of codes</v-btn>
          </v-list-tile>

          <v-list-tile>
            <v-dialog v-model="copycodes" width="500" >
              <template v-slot:activator="{ on, attrs }">
                <v-btn flat small v-bind="attrs" v-on="on" >
                  Copy codes from previous apointments</v-btn>
              </template>
              <copy-codes :appointment='appointment'
                @update='clearAndLoadAppointments'
                @close='copycodes=false' />
            </v-dialog>
          </v-list-tile>

          <v-list-tile>
            <!-- apply these codes to all appointments in this series -->
            <apply-appointment-codes
              :disabled='table.data.length === 0 || appointment.recurring_appointment === null'
              :appointment='appointment' />
          </v-list-tile>

          <v-list-tile>
            <!-- apply these codes to the client's profile -->
            <clone-appointment-codes
              v-if='withClone'
              :disabled='table.data.length === 0'
              :appointment='appointment' />
          </v-list-tile>
        </v-list>
      </v-menu>
      <strong class='overline' v-if='title' v-text='title' />
      <strong class='overline' v-else >
        {{appointment.title}}. {{dateformat(appointment.start_time, 'ddd DD MMM @ hh:mma')}}
      </strong>

      <v-spacer />
      <v-btn v-if='showOrder'
        :disabled='codeOrder && Object.keys(codeOrder).length === 0'
        :loading='requests.setorder.loading'
        @click='setOrder' small color="primary" >Save order</v-btn>
      <v-btn v-if='showOrder' @click='showOrder=false' small flat >Cancel</v-btn>
      <v-btn icon small
        @click='clearAndLoadAppointments' :loading='appointmentRequest.loading' ><v-icon small >replay</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-alert :type='alert.type' v-model='alert.visible' dismissible >
      {{alert.message}}
    </v-alert>
    <!-- <v-snackbar top :color='snack.type' v-model='snack.visible' >
      {{ snack.message }}
      <v-btn color="pink" flat @click="snack.visible = false" >
        Close
      </v-btn>
    </v-snackbar> -->
    <!-- <pre v-text="table.data" /> -->
    <crud-table v-if='table' flat dense with-inline-delete
      :selectable=false
      @add='addCode'
      @edit='editCode'
      @delete='deleteCode'
      :loading='codesUpdating || appointmentRequest.loading'
      :headers='table.headers'
      :deleteable='true'
      :items='table.data'
      :dialog-width='600'
      :no-data-text="$t('messages.nocodes')" >

      <template slot="before-table" slot-scope="props" >
        <v-layout v-if="props.selected && props.selected.length > 0" class="mx-2 mb-2" >
          <v-flex xs8 >
            <icd-input persistent-hint
              v-model="icdCode"
              label="Apply ICD-10 code to selected rows"
              hint="Type an ICD-10 code, or click the search icon to search (ctrl s). " />
          </v-flex>
          <v-flex xs4 >
            <v-btn small outline
              @click="setcodes(props.selected)"
              :disabled="!icdCode"
              color="primary"
              class="mt-4" >Set ICD
              <span class="hidden-xs-only ml-1" > for selected line items</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>

      <div slot='dialog-header' >
        <v-snackbar class='ma-0' absolute top :color='snack.type' v-model='snack.visible' >
          {{ snack.message }}
          <v-btn color="pink" flat @click="snack.visible = false" >
            Close
          </v-btn>
        </v-snackbar>
      </div>

      <template slot='order' slot-scope="props" >
        <!-- <pre v-text="props" /> -->
        <v-text-field hide-details class="caption"
          @click.stop="noop"
          @input='updateOrder(props.item, props.value)'
          v-model="props.value"
          type="number" />
        <!-- <v-text-field v-model="props.value" type="number" style='width:25px;' /> -->
      </template>

      <template slot='field-icd10' slot-scope="props" >
        <v-dialog v-model="ICD10codepicker" fullscreen>
          <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
          <v-toolbar dark dense short :color='themeColor' >
            <v-toolbar-title >{{ $t('dialogs.titles.icd10picker') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click='ICD10codepicker=false' ><v-icon>close</v-icon></v-btn>
          </v-toolbar>
          <icd-picker
            @input='setIcdCode(props)'
            :touch='icdtouch'
            :initial-search-string='codeSearchString'
            v-model='code' >
          </icd-picker>
        </v-dialog>
        <v-flex xs12 >
          <v-text-field
            append-icon='search'
            @click:append="showICDPicker(props)"
            @input='typedIcd10Code = props.selectedRow[props.header.value]'
            label='ICD10 code'
            hint='Please provide an ICD10 diagnosis code'
            required
            :rules = "[v => !!v || 'IDC10 code is required']"
            v-model='props.selectedRow[props.header.value]' >
          </v-text-field>
        </v-flex>
        <v-flex xs12 >
        <template v-for='(code, index) in suggestedICD10' >
          <v-chip
            v-if='code'
            @click = 'props.selectedRow.icd10 = code'
            :key='`${code}-${index}`'
            small label >
            {{code}}
          </v-chip>
        </template>
        </v-flex>
      </template>
      <template slot='field-process' slot-scope="props" >
        <v-flex xs12 >
        <v-dialog v-model="processcodepicker" fullscreen>
           <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
            <v-toolbar dark dense short :color='themeColor' >
              <v-toolbar-title >{{ $t('dialogs.titles.processpicker') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click='processcodepicker=false' ><v-icon>close</v-icon></v-btn>
            </v-toolbar>
          <process-code-picker
            v-model='process' :initial-search-string='processSearchString'
            @input='setProcessCode(props)' ></process-code-picker>
        </v-dialog>

        <v-text-field
          append-icon='search'
          label='Process code'
          @click:append='showProcessPicker(props)'
          @input='typedProcessCode = props.selectedRow[props.header.value]'
          required
          :rules = "[v => !!v || 'Process code is required (just put a - if you really don\'t want to use it)']"
          v-model='props.selectedRow[props.header.value]' >
        </v-text-field>
        </v-flex>
      </template>
      <v-layout row wrap slot='field-nappi' slot-scope="props" >
        <v-flex xs12 class='text-xs-right' >
          <v-btn
            v-if='moreCodes === false'
            @click='moreCodes = true'
            flat small
            class='ma-0' >More code options</v-btn>
          <v-btn
            v-else
            @click='moreCodes = false'
            flat small
            class='ma-0' >Fewer options</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if='moreCodes'
            label='NAPPI code'
            v-model='props.selectedRow[props.header.value]' >
          </v-text-field>
        </v-flex>
      </v-layout>

      <template slot='field-price' slot-scope="props" >
        <v-flex xs12>
        <v-text-field
          :prefix='defaultCurrency'
          label='Price'
          type='number'
          required
          :rules = "[v => !!v || 'Price is required']"
          v-model='props.selectedRow[props.header.value]' >
        </v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-chip small label
            v-for='(code, index) in suggestedPrices'
            @click = 'props.selectedRow.price = code.price; props.selectedRow.process = code.name'
            :key='index' >
            <strong>{{code.name}}</strong>&nbsp;
            {{formatCurrency(code.currency, (parseFloat(code.price))) }}
          </v-chip>
        </v-flex>
      </template>
    </crud-table>

    <v-card-actions v-if='withTotal'
      class='grey lighten-2' >
      <v-chip small label outline class='pa-0' >#{{appointmentId}}</v-chip>
      <v-btn v-if='withDone' @click="$emit('close')" flat text >Done</v-btn>
      <v-spacer></v-spacer>
      <h3 class='subheading mr-4' v-if='table.data && table.data.length > 0' >
        Total:
        {{ formatCurrency(appointment.currency, totalPrice) }}
      </h3>
    </v-card-actions>

    <!-- <v-card-actions v-if='withInvoiceable' >
      <v-checkbox class='ml-2'
        label="Appointment is ready for invoicing"
        color="success"
        @change='saveInvoiceable'
        :loading='appointmentRequest.loading || editRequest.loading'
        v-model="appointment.invoiceable" ></v-checkbox>
    </v-card-actions > -->
</v-card>
<v-card flat v-else >
  <v-card-text v-if='!this.appointmentRequest.loading' >
    <div v-if='appointmentId && appointmentId > 0' >
      <v-icon >warning</v-icon> unable to load codes.
      <v-btn
        :loading="appointmentRequest.loading"
        flat @click='loadAppointments' >Try again </v-btn>
    </div>
    <v-alert :value='true' v-else >
      Something has gone wrong.
      Try choosing another appointment and then
      coming back to this one?
    </v-alert>
  </v-card-text>
  <v-card-text v-else class='text-xs-center' >
    <v-progress-circular indeterminate color='amber' size='32' width='2' >
    </v-progress-circular>
  </v-card-text>
</v-card>
</div>
</template>

<script>
import {
  CODETYPES,
  ACTIVE_APPOINTMENT_DETAIL
} from '@/store/constants'
import CrudTable from '@/components/CrudTable'
import IcdPicker from '@/components/pickers/IcdPicker'
import ProcessCodePicker from '@/components/pickers/ProcessCodePicker'
import CloneAppointmentCodes from '@/components/appointment/CloneAppointmentCodes.vue'
import ApplyAppointmentCodes from '@/components/appointment/ApplyAppointmentCodes.vue'
import CopyCodes from '@/components/appointment/CopyCodes.vue'
import IcdInput from '@/components/forms/IcdInput.vue'
import Vue from 'vue'

export default {
  name: 'AppointmentCodes',
  components: {
    CrudTable,
    IcdPicker,
    IcdInput,
    ProcessCodePicker,
    CloneAppointmentCodes,
    CopyCodes,
    ApplyAppointmentCodes
  },
  props: {
    value: { type: Object, default: () => { return {} } },
    title: { type: String, required: false },
    appointmentId: { },
    appointments: { type: Array, default: () => { return [] } },
    dark: { type: Boolean, default: false },
    withClone: { type: Boolean, default: true },
    withDone: { type: Boolean, default: true },
    editable: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false },
    withInvoiceable: { type: Boolean, default: false },
    withTotal: { type: Boolean, default: false },
    touch: { type: Number, default: 10 }
  },
  data () {
    return {
      icdCode: '',
      appointment: {},
      copycodes: false,
      showOrder: false,
      ICD10codepicker: false,
      processcodepicker: false,
      showCodesSetResult: false,
      moreCodes: false,
      processSearchString: null,
      codeSearchString: null,
      typedProcessCode: null,
      typedIcd10Code: null,
      icdtouch: 1,
      process: null,
      code: null,
      resource: 'appointment.codes',
      requests: {
        appointment: ACTIVE_APPOINTMENT_DETAIL,
        delete: 'appointment-codes-delete-request',
        edit: 'appointment-codes-edit-request',
        add: 'appointment-codes-add-request',
        setorder: {
          resource: 'ag.practitioner.appointments',
          extra: 'actions/set_code_order',
          method: 'post'
        }
      },
      alert: {
        message: '',
        type: 'success',
        visible: false
      },
      snack: {
        message: '',
        type: 'success',
        visible: false
      },
      codeOrder: {}
    }
  },
  computed: {
    appointmentRequest () {
      return this.$store.getters.getRequestById(this.requests.appointment, true)
    },
    appointmentRequestStatus () {
      return this.appointmentRequest.status
    },
    deleteRequest () {
      return this.$store.getters.getRequestById(this.requests.delete, true)
    },
    addRequest () {
      return this.$store.getters.getRequestById(this.requests.add, true)
    },
    addRequestStatus () {
      return this.addRequest.status
    },
    editRequest () {
      return this.$store.getters.getRequestById(this.requests.edit, true)
    },
    editRequestStatus () {
      return this.editRequest.status
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    },
    codesUpdating () {
      return (this.deleteRequest.loading || this.editRequest.loading || this.addRequest.loading)
    },
    orderRequestStatus () {
      return this.requests.setorder.status
    },
    suggestedICD10 () {
      if (this.typedIcd10Code &&
          this.typedIcd10Code.length > 0 &&
          this.getCachedCodeSuggestions &&
          this.getCachedCodeSuggestions.icd10) {
        let items = this.getCachedCodeSuggestions.icd10.filter((item) => {
          if (item && item.startsWith(this.typedIcd10Code)) {
            return item
          }
        })
        return items.slice(0, 3) // max 3
      }
      return []
    },
    suggestedPrices () {
      if (this.typedProcessCode &&
          this.typedProcessCode.length > 2 &&
          this.getCachedCodeSuggestions &&
          this.getCachedCodeSuggestions.process) {
        let items = this.getCachedCodeSuggestions.process.filter((item) => {
          if (item && item.name && item.name.startsWith(this.typedProcessCode)) {
            return item
          }
        })
        return items.slice(0, 6)
      }
      return []
    },
    table () {
      // let keys = Object.keys(excluded)
      let headers = [
        {text: 'ICD10 Code', value: 'icd10'},
        {text: 'Process Code', value: 'process'},
        {text: 'NAPPI', value: 'nappi', required: false},
        {text: 'Price', value: 'price', required: true, type: 'number'}
      ]
      if (this.showOrder) {
        headers = [{text: 'Order', value: 'order'}].concat(headers)
      }
      let activeCodes = []
      if (this.appointment && this.appointment.id && this.appointment.codes) {
        for (let row of this.appointment.codes) {
          for (let code of CODETYPES) {
            if (row[code] && row[code] !== null) {
              if (activeCodes.indexOf(code) === -1) {
                // headers.push({'text': code, 'value': code})
                activeCodes.push(code)
              }
            }
          }
        }
      }
      return {
        headers: headers,
        activeCodeTypes: activeCodes,
        data: this.appointment.codes || []
      }
    },
    totalPrice () {
      if (this.appointment.codes) {
        return this.appointment.codes.reduce((sum, item) => {
          return parseFloat(sum) + parseFloat(item.price)
        }, 0)
      }
      return 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    },
    appointment () {
      this.$emit('input', this.appointment)
    },
    touch () {
      let vm = this
      this.showOrder = false
      window.setTimeout(() => {
        if (vm.appointmentId) { vm.clearAndLoadAppointments() }
      }, 100)
    },
    ICD10codepicker () {
      if (this.ICD10codepicker) {
        this.icdtouch++
      }
    },
    appointmentId: {
      immediate: true,
      handler () {
        this.clearAndLoadAppointments()
      }
    },
    appointmentRequestStatus () {
      if (this.appointmentRequestStatus === 200) {
        this.appointment = this.getObjectPath(this.appointmentRequest, 'result.data', {})
      }
    },
    orderRequestStatus () {
      if (this.orderRequestStatus > 199) {
        this.clearAndLoadAppointments()
        this.showOrder = false
      }
    },
    totalPrice () {
      if (this.totalPrice && this.totalPrice > 0) {
        this.$emit('pricechange', this.totalPrice)
      }
    },
    addRequestStatus () {
      if (this.addRequestStatus === 201) {
        this.$emit('added')
        this.showAlert(
          'Code added',
          'success',
          'snack'
        )
        this.loadAppointments()
      }
      if (this.addRequestStatus > 299) {
        this.showAlert(
          'Unable to add code. Please try again',
          'error'
        )
      }
    },
    editRequestStatus () {
      if (this.editRequestStatus === 200) {
        this.$emit('edited')
      }
      if (this.editRequestStatus > 299) {
        this.showAlert(
          'Unable to edit code',
          'error'
        )
      }
      this.loadAppointments()
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.$emit('deleted')
      }
      if (this.deleteRequestStatus === 404) {
        this.showAlert(
          'Unable to delete code',
          'error'
        )
      }
      this.loadAppointments()
    }
  },
  methods: {
    noop () { },
    setcodes (selected) {
      selected.forEach(item => {
        item.icd10 = this.icdCode
      })
    },
    updateOrder (item, order) {
      order = parseInt(order)
      if (!isNaN(order)) {
        Vue.set(this.codeOrder, item.id, order)
      }
    },
    showAlert (msg, type, alertType = 'alert') {
      this[alertType].message = msg
      this[alertType].type = type
      this[alertType].visible = true
    },
    saveInvoiceable () {
      if (this.appointment && this.appointment.id) {
        let data = {invoiceable: this.appointment.invoiceable}
        this.$appointmentguru
          .resource('appointment')
          .id(this.requests.edit)
          .save(this.appointment.id, data)
      }
    },
    clearAndLoadAppointments () {
      if (this.appointmentId) {
        this.appointment = {}
        this.loadAppointments()
      }
    },
    loadAppointments () {
      if (this.appointmentId) {
        // this.appointment = {}
        this.getAppointment(this.appointmentId)
      }
    },
    addCode (code) {
      code.appointment = this.appointment.id
      let data = JSON.stringify(code)
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.add)
        .create(data)
    },
    editCode (code) {
      let data = JSON.stringify(code)
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.edit)
        .save(code.id, data)
    },
    deleteCode (data) {
      let id = data.id
      let params = {appointment_id: this.appointment.id}
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.delete)
        .delete(id, params)
    },
    showProcessPicker (props) {
      this.processcodepicker = true
      this.processSearchString = props.selectedRow[props.header.value]
    },
    showICDPicker (props) {
      this.ICD10codepicker = true
      this.codeSearchString = props.selectedRow[props.header.value]
    },
    setProcessCode (props) {
      this.typedProcessCode = this.process.name
      props.selectedRow[props.header.value] = this.process.name
      if (this.process.discovery_rate) {
        props.selectedRow.price = this.process.discovery_rate
      }
      if (this.process.price) {
        props.selectedRow.price = this.process.price
      }
      this.processcodepicker = false
    },
    setIcdCode (props) {
      props.selectedRow[props.header.value] = this.code.name
      this.ICD10codepicker = false
    },
    setOrder () {
      // console.log(this.codeOrder)
      this.requests.setorder.resourceId = this.appointmentId
      this.requests.setorder.data = {order: JSON.stringify(this.codeOrder)}
      this.$request('save', this.requests.setorder)
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          nocodes: 'This appointment has no codes'
        },
        alerts: {
          addedcode: 'Code successfully added'
        },
        dialogs: {
          titles: {
            icd10picker: 'Find an ICD10 code',
            processpicker: 'Find a code'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentCodes.vue?3e9b4171